var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container trading-view"},[_c('div',{staticClass:"tradingview-widget-container d-none",attrs:{"id":"tradingview_wrapper"}},[_c('div',{staticClass:"trading-view-in",attrs:{"id":"tradingview_54dbc"}})])])
}]

export { render, staticRenderFns }